import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { EmployerScreeningQuestion } from './employer-screening-question.type';
export const useEmployerScreeningQuestionsStore = defineStore('employerScreeningQuestions', () => {
  const frequentlyUsedQuestions = ref<EmployerScreeningQuestion[]>([]);

  // alphabetized list
  return {
    frequentlyUsedQuestions,
  };
});
